export default __webpack_public_path__ + "static/media/cardBack.34d45e9f.png";